import axios, { type AxiosResponse } from '@fs/zion-axios'
import { ROOTSTECH_SERVICE as SERVICE } from '../../serviceNames'
import { JSON_CONFIG } from '../../helpers/requestConfig'

// DOCS: https://www.familysearch.org/service/rootstech/rtc2022/helpdesk/

const BASE = `${SERVICE}/rtc2022/helpdesk`
const GENERALISTS = `${BASE}/generalists`
const VENDORS = `${BASE}/vendors`

export const getVolunteer = (): Promise<AxiosResponse> => {
  return axios.get(`${GENERALISTS}/CURRENT`)
}

export const updateVolunteer = ({
  cisId,
  volunteerData,
}: {
  cisId: string
  volunteerData: Record<string, unknown>
}): Promise<AxiosResponse> => {
  return axios.post(`${GENERALISTS}/${cisId}`, volunteerData)
}

export const createVolunteer = ({
  volunteerData,
}: {
  volunteerData: Record<string, unknown>
}): Promise<AxiosResponse> => {
  return axios.post(`${GENERALISTS}`, volunteerData)
}

export const getAvailableVendorReps = (vendorId: string, eventName: string): Promise<AxiosResponse> => {
  return axios.get(`${VENDORS}/${vendorId}/reps`, { params: { event: eventName, available: false, limit: 49 } })
}

/** Create or update a relationship between a user and vendor for an event */
export const upsertVendorRep = (vendorId: string, eventName: string, cisId: string): Promise<AxiosResponse> => {
  return axios.put(`${VENDORS}/${vendorId}/events/${eventName}/reps/${cisId}`, null, JSON_CONFIG)
}

export const deleteVendorRep = (vendorId: string, eventName: string, cisId: string): Promise<AxiosResponse> => {
  return axios.delete(`${VENDORS}/${vendorId}/events/${eventName}/reps/${cisId}`)
}
